<template>
  <div
    class="p-input-component"
    :class="{ 'd-flex align-items-center': inline }"
  >
    <div
      v-if="label"
      class="d-flex align-items-center"
      :class="{ 'me-2': inline }"
    >
      <label
        :for="id"
        class="form-label"
        :class="[labelClass, { 'mb-0': inline }]"
        v-bind="labelElProps"
        v-html="formattedLabel"
      />
      <div
        v-if="required || mandatory"
        class="required-dot"
        v-bind="divElProps"
      />
      <label v-if="isLabelUpdate"
        :for="id"
        class="form-label"
        :class="[labelClass, { 'mb-0': inline }]"
        v-bind="updateLabel"
        v-html="formattedUpdateLabel"
      />

    </div>
    <input
      v-if="mask !== null"
      :id="id"
      v-maska="mask"
      :type="type"
      class="form-control"
      :class="inputClass"
      :value="value"
      :required="required"
      :disabled="disabled"
      v-bind="inputProps"
      :placeholder="placeholder"
      :readonly="readonly"
      :maxlength="maxlength"
      :autocomplete="autocomplete"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    >
    <input
      v-else
      :id="id"
      :type="type"
      class="form-control"
      :class="inputClass"
      :value="value"
      :required="required"
      :disabled="disabled"
      v-bind="inputProps"
      :placeholder="placeholder"
      :readonly="readonly"
      :maxlength="maxlength"
      :autocomplete="autocomplete"
      @input="$emit('input', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    >
  </div>
</template>

<script>
import { commonInputProps } from '~/helpers/component-props/input-props'

export default {
  name: 'TextField',
  props: {
    ...commonInputProps,
    mask: {
      type: [Object, String, Array],
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    labelClass: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: null
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    autocomplete: {
       type: String,
       default: 'off'
    },
    inputClass: {
      type: String,
      default: ''
    },
    isLabelUpdate : {
      type: Boolean,
      default: false
    },
    updateLabel : {
        type: String,
        default: ''
    }
  },
  computed: {
    formattedLabel () {
      return this.label.replace(/\(([^)]+)\)/, '<span class="highlight">($1)</span>')
    },
    formattedUpdateLabel () {
      return this.updateLabel.replace(/\(([^)]+)\)/, '<span class="highlight">($1)</span>')
    }
  }
}
</script>

<style lang="scss" scoped>
.p-input-component {
  .form-control:disabled, .form-control[readonly] {
    background-color: #e9ecef !important;
    opacity: 1;
  }
  .form-label {
    margin-bottom: 5px;
    margin-right: 10px;
    max-width: 18rem;
    white-space: normal;
    overflow: visible;
    word-wrap: break-word;
  }

  .fields-font {
     font: normal normal normal 14px/16px Arial;
     margin-left: 0;
  }

  .red-background {
        background-color: #FF8B8B;
  }
}
</style>
<style>
.highlight {
  color: #FF0000 !important;
}
</style>
